(function () {
  if (window.__gzProductSectionInit) { window.__gzProductSectionInit(); return; }
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = (!reduced && 'IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('gz-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' })
    : null;
  function init(root) {
    var sections = (root || document).querySelectorAll('.t3-products-section');
    if (!sections.length) return;
    document.documentElement.classList.add('gz-motion-ready');
    sections.forEach(function (section) {
      var cards = section.querySelectorAll('.t3-prod-card:not([data-gz-reveal-bound])');
      cards.forEach(function (card, index) {
        card.setAttribute('data-gz-reveal-bound', '1');
        card.classList.add('gz-reveal');
        card.style.transitionDelay = Math.min(index % 5, 4) * 60 + 'ms';
        if (reduced || !observer) {
          card.classList.add('gz-visible');
        } else {
          observer.observe(card);
        }
      });
    });
  }
  window.__gzProductSectionInit = init;
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', function () { init(); })
    : init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

/* Global "Add to Cart" nudge + card safety net + white bg + mobile 2nd-image + quick-view styles */
(function () {
  if (window.__gzGlobalShakeInit) { window.__gzGlobalShakeInit(); return; }
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!document.getElementById('gz-shake-style')) {
    var st = document.createElement('style');
    st.id = 'gz-shake-style';
    st.textContent =
      '@keyframes gz-shake{0%,78%,100%{transform:translateY(0)}83%{transform:translateY(-7px)}88%{transform:translateY(4px)}92%{transform:translateY(-3px)}96%{transform:translateY(1px)}}' +
      '.gz-shake-active{animation:gz-shake 3.4s ease-in-out infinite}' +
      '.gz-shake-active:disabled,.gz-shake-active[disabled],.gz-shake-active[data-added="true"]{animation:none!important}' +
      '@media(prefers-reduced-motion:reduce){.gz-shake-active{animation:none!important}}' +
      '.t3-prod-thumb,.gz-related-card__media,.gz-search-media{border-radius:12px!important;overflow:hidden!important;aspect-ratio:1/1!important;background:#fff!important}' +
      '.t3-prod-thumb>img,.gz-related-card__media>img,.gz-search-media>img{border-radius:0!important}' +
      '.t3-scope{background:#fff}' +
      '.t3-prod-thumb.gz-2nd-shown .t3-prod-img-primary{opacity:0!important;transform:scale(1.02)!important}' +
      '.t3-prod-thumb.gz-2nd-shown .t3-prod-img-secondary{opacity:1!important;transform:scale(1.05)!important}' +
      '.t3-prod-card{position:relative}' +
      '.gz-product-eye{position:absolute;top:10px;inset-inline-end:10px;z-index:6;width:38px;height:38px;display:flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.95);color:#172460;box-shadow:0 4px 14px rgba(23,36,96,.16);cursor:pointer;transition:transform .15s ease,background-color .15s ease,opacity .2s ease}' +
      '.gz-product-eye svg{width:19px;height:19px;fill:none;stroke:currentColor;stroke-width:1.9}' +
      '.gz-product-eye:hover{background:#fff;transform:scale(1.08)}' +
      '@media(hover:hover){.gz-product-eye{opacity:0}.t3-prod-card:hover .gz-product-eye{opacity:1}}' +
      '@media(max-width:749px){' +
        '.t3-prod-card>a{display:flex!important;flex-direction:column!important}' +
        '.gz-product-eye,.gz-search-eye{position:static!important;align-self:center!important;display:flex!important;opacity:1!important;transform:none!important;width:32px!important;height:32px!important;margin:8px auto 4px!important;box-shadow:0 4px 12px rgba(23,36,96,.16)!important}' +
        '.gz-product-eye svg{width:16px!important;height:16px!important}' +
        '.t3-prod-info h3{display:-webkit-box!important;-webkit-line-clamp:2!important;-webkit-box-orient:vertical!important;overflow:hidden!important;min-height:2.8em!important}' +
        '.t3-price-row{flex-wrap:nowrap!important}' +
        '.t3-price-row .t3-price,.t3-price-row .t3-old-price{white-space:nowrap!important}' +
        '.t3-old-price{font-size:11.5px!important}' +
      '}' +
      '.gz-qv-overlay{position:fixed;inset:0;z-index:9998;background:rgba(3,20,80,.5);opacity:0;visibility:hidden;transition:opacity .25s ease,visibility .25s ease}' +
      '.gz-qv-overlay.is-open{opacity:1;visibility:visible}' +
      '.gz-qv{position:fixed;z-index:9999;left:50%;top:50%;transform:translate(-50%,-46%);width:min(880px,94vw);max-height:88vh;overflow:auto;background:#fff;border-radius:22px;box-shadow:0 30px 80px rgba(3,20,80,.35);opacity:0;visibility:hidden;transition:opacity .25s ease,transform .25s ease,visibility .25s ease;font-family:Poppins,Cairo,sans-serif;color:#172460}' +
      '.gz-qv.is-open{opacity:1;visibility:visible;transform:translate(-50%,-50%)}' +
      '.gz-qv__close{position:absolute;top:12px;inset-inline-end:12px;width:38px;height:38px;border:0;border-radius:50%;background:#f3f5fc;color:#172460;font-size:20px;cursor:pointer;z-index:2}' +
      '.gz-qv__grid{display:grid;grid-template-columns:1fr 1fr;gap:24px;padding:22px}' +
      '.gz-qv__media img{width:100%;aspect-ratio:1/1;object-fit:contain;background:#fff;border-radius:16px;border:1px solid #eef1f7}' +
      '.gz-qv__thumbs{display:flex;gap:8px;margin-top:10px;flex-wrap:wrap}' +
      '.gz-qv__thumbs button{width:54px;height:54px;padding:2px;border:1.5px solid #e2e6f5;border-radius:10px;background:#fff;cursor:pointer}' +
      '.gz-qv__thumbs button.is-active{border-color:#ffb614}' +
      '.gz-qv__thumbs img{width:100%;height:100%;object-fit:contain}' +
      '.gz-qv__title{margin:2px 0 8px;font-size:20px;font-weight:800}' +
      '.gz-qv__price{display:flex;gap:10px;align-items:baseline;margin-bottom:12px}' +
      '.gz-qv__price .now{font-size:20px;font-weight:800;color:#24398E}' +
      '.gz-qv__price .was{font-size:14px;color:#9AA5C7;text-decoration:line-through}' +
      '.gz-qv__desc{font-size:13.5px;line-height:1.7;color:#5C669A;margin-bottom:16px;max-height:130px;overflow:auto}' +
      '.gz-qv__opt{width:100%;height:44px;border:1px solid #dfe4f3;border-radius:12px;padding:0 12px;margin-bottom:12px;color:#172460;font:inherit;background:#fff}' +
      '.gz-qv__add{width:100%;min-height:50px;border:0;border-radius:999px;background:#FFB614;color:#1A245D;font-weight:800;font-size:15px;cursor:pointer}' +
      '.gz-qv__add:disabled{opacity:.5;cursor:not-allowed}' +
      '.gz-qv__more{display:inline-block;margin-top:12px;color:#24398E;font-weight:700;font-size:13px;text-decoration:none}' +
      '.gz-qv__loading{padding:60px;text-align:center;color:#5C669A}' +
      '@media(max-width:749px){.gz-qv{left:0;right:0;bottom:0;top:auto;width:100%;max-height:92vh;transform:translateY(100%);border-radius:22px 22px 0 0}.gz-qv.is-open{transform:translateY(0)}.gz-qv__grid{grid-template-columns:1fr;gap:14px;padding:18px}.gz-qv__media img{aspect-ratio:4/3}}' +
      '@media(prefers-reduced-motion:reduce){.gz-qv,.gz-qv-overlay{transition:none!important}}';
    (document.head || document.documentElement).appendChild(st);
  }

  var SEL = [
    '[data-gz-shake]', '.add-to-cart-button', 'button[name="add"]', '.t3-add-btn', '.gz-add-button',
    '.gz-sticky-atc__button', '.gz-related-card button', '[data-t3-quick-add]', '.quick-add__submit',
    '.quick-order-list__add', '.sticky-add-to-cart button[name="add"]'
  ].join(',');

  function bind(el) {
    if (!el || el.dataset.gzShakeBound === '1') return;
    if (el.closest && el.closest('.shopify-payment-button')) return;
    el.dataset.gzShakeBound = '1';
    if (reduced) return;
    el.style.animationDelay = (Math.random() * 2.6).toFixed(2) + 's';
    el.classList.add('gz-shake-active');
  }
  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SEL).forEach(bind);
    if (root && root.nodeType === 1 && root.matches && root.matches(SEL)) bind(root);
  }
  function boot() {
    scan(document);
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) { if (node.nodeType !== 1) return; scan(node); });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  window.__gzGlobalShakeInit = function () { scan(document); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

/* Mobile: first tap on a product image reveals its 2nd photo (no navigation) */
(function () {
  if (window.__gzCard2ndInit) return;
  window.__gzCard2ndInit = true;
  var touch = window.matchMedia('(hover: none)');
  document.addEventListener('click', function (e) {
    if (!touch.matches) return;
    var thumb = e.target.closest && e.target.closest('.t3-prod-thumb.t3-has-secondary');
    if (!thumb) return;
    if (e.target.closest('.gz-product-eye, .t3-add-btn, button')) return;
    if (thumb.dataset.gz2 === '1') return;
    e.preventDefault();
    e.stopPropagation();
    document.querySelectorAll('.t3-prod-thumb.gz-2nd-shown').forEach(function (t) {
      if (t !== thumb) { t.classList.remove('gz-2nd-shown'); t.dataset.gz2 = ''; }
    });
    thumb.classList.add('gz-2nd-shown');
    thumb.dataset.gz2 = '1';
    clearTimeout(thumb.__gz2t);
    thumb.__gz2t = setTimeout(function () { thumb.classList.remove('gz-2nd-shown'); thumb.dataset.gz2 = ''; }, 3500);
  }, true);
})();

/* Quick View — lightweight modal from the eye icon; uses /products/{handle}.js + window.T3Cart.add */
(function () {
  if (window.__gzQuickViewInit) return;
  window.__gzQuickViewInit = true;
  var overlay, modal, cache = {};

  function money(cents) {
    var n = (Math.round(Number(cents) || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return 'LE ' + n;
  }
  function build() {
    overlay = document.createElement('div'); overlay.className = 'gz-qv-overlay';
    modal = document.createElement('div'); modal.className = 'gz-qv';
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
    document.body.appendChild(overlay); document.body.appendChild(modal);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  function open() { if (!overlay) build(); overlay.classList.add('is-open'); modal.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
  function close() { if (!overlay) return; overlay.classList.remove('is-open'); modal.classList.remove('is-open'); document.documentElement.style.overflow = ''; }

  function render(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
    var imgs = (p.images || []).map(function (u) { return u.indexOf('//') === 0 ? 'https:' + u : u; });
    var hero = imgs[0] || '';
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    var desc = (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    var hasRealVariants = (p.variants || []).length > 1 || (p.variants && p.variants[0] && p.variants[0].title !== 'Default Title');
    modal.innerHTML =
      '<button type="button" class="gz-qv__close" aria-label="Close">×</button>' +
      '<div class="gz-qv__grid">' +
        '<div class="gz-qv__media">' +
          '<img id="gz-qv-hero" src="' + hero + '" alt="' + (p.title || '') + '">' +
          (imgs.length > 1 ? '<div class="gz-qv__thumbs">' + imgs.slice(0, 6).map(function (u, i) {
            return '<button type="button" data-i="' + i + '" class="' + (i === 0 ? 'is-active' : '') + '"><img src="' + u + '" alt=""></button>';
          }).join('') + '</div>' : '') +
        '</div>' +
        '<div class="gz-qv__info">' +
          '<h3 class="gz-qv__title">' + (p.title || '') + '</h3>' +
          '<div class="gz-qv__price"><span class="now">' + money(v.price) + '</span>' + (onSale ? '<span class="was">' + money(v.compare_at_price) + '</span>' : '') + '</div>' +
          (desc ? '<div class="gz-qv__desc">' + desc.slice(0, 320) + (desc.length > 320 ? '…' : '') + '</div>' : '') +
          (hasRealVariants ? '<select class="gz-qv__opt" id="gz-qv-variant">' + (p.variants || []).map(function (x) {
            return '<option value="' + x.id + '"' + (x.available ? '' : ' disabled') + (x.id === v.id ? ' selected' : '') + '>' + x.title + (x.available ? '' : ' - Sold out') + '</option>';
          }).join('') + '</select>' : '') +
          '<button type="button" class="gz-qv__add" data-gz-shake ' + (v.available ? '' : 'disabled') + '>' + (v.available ? 'Add to Cart' : 'Sold out') + '</button>' +
          '<a class="gz-qv__more" href="/products/' + p.handle + '">View full details</a>' +
        '</div>' +
      '</div>';
    modal.querySelector('.gz-qv__close').addEventListener('click', close);
    modal.querySelectorAll('.gz-qv__thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        modal.querySelector('#gz-qv-hero').src = imgs[+b.dataset.i];
        modal.querySelectorAll('.gz-qv__thumbs button').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
      });
    });
    var sel = modal.querySelector('#gz-qv-variant');
    var addBtn = modal.querySelector('.gz-qv__add');
    function currentVariant() {
      var id = sel ? sel.value : v.id;
      return (p.variants || []).filter(function (x) { return String(x.id) === String(id); })[0] || v;
    }
    if (sel) sel.addEventListener('change', function () {
      var cv = currentVariant();
      modal.querySelector('.gz-qv__price .now').textContent = money(cv.price);
      addBtn.disabled = !cv.available;
      addBtn.textContent = cv.available ? 'Add to Cart' : 'Sold out';
    });
    addBtn.addEventListener('click', function () {
      var cv = currentVariant();
      if (!cv || !cv.available) return;
      addBtn.disabled = true;
      var done = function () { close(); };
      try {
        if (window.T3Cart && window.T3Cart.add) { window.T3Cart.add(cv.id, 1).then(done).catch(done); }
        else { fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: cv.id, quantity: 1 }) }).then(function () { window.location.href = '/cart'; }); }
      } catch (e) { window.location.href = '/products/' + p.handle; }
    });
    if (window.__gzGlobalShakeInit) window.__gzGlobalShakeInit();
  }
  function load(handle) {
    open();
    modal.innerHTML = '<button type="button" class="gz-qv__close" aria-label="Close">×</button><div class="gz-qv__loading">Loading...</div>';
    modal.querySelector('.gz-qv__close').addEventListener('click', close);
    if (cache[handle]) { render(cache[handle]); return; }
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('x'); return r.json(); })
      .then(function (p) { cache[handle] = p; render(p); })
      .catch(function () { window.location.href = '/products/' + handle; });
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-gz-quick-view]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = trigger.getAttribute('data-gz-quick-view');
    if (handle) load(handle);
  }, true);
})();
